import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_ROUTES } from '@services/api.const';
import { NotificationsService } from '@services/notifications.service';
import { API_PAYMENT_ROUTES } from '@services/paypal.service';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private _notification: NotificationsService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          if (req.method === 'DELETE' && !req.url.includes('preview=true')) {
            const status = event?.statusText;
            if (event.status === 200) {
              this._notification.success('Success', event.body?.message);
            } else {
              this._notification.error(status, event?.body?.message ?? event.statusText);
            }
          }

          if ((req.method === 'PUT' || req.method === 'POST') && !req.url.includes('?preview=true')) {
            const propertySuccessInBody = !!event.body && 'success' in event.body;
            const doubleCheck = !propertySuccessInBody || (propertySuccessInBody && event.body.success);

            if (event.status === 200) {
              const backgroundApi = [
                API_ROUTES.CHECK_SEAT_AVAILABILITY,
                API_ROUTES.MEMBERSHIP_EXPIRY,
                API_PAYMENT_ROUTES.ADD_UNCOMPLETED_PAID_TRANSACTION,
                API_ROUTES.LOGIN,
              ];

              if (!backgroundApi.includes(req.url)) {
                this._notification.success('Success', event?.body?.message);
              } else {
                if (!doubleCheck) {
                  this._notification.error('Failed', event?.body?.message);
                }
              }
            } else {
              this._notification.error(status, event?.body?.message ?? event.statusText);
            }
          }

          if (
            req.method === 'GET' &&
            !(event?.body && event?.body?.success && !!(event.body?.data || event.body?.content || event.body.body))
          ) {
            const routes = [
              API_ROUTES.BOOKED_TICKETS_REPORT,
              API_ROUTES.EXPORT_MEMBERS,
              API_ROUTES.EXPORT_NON_MEMBERS,
              API_ROUTES.USER_INFO,
            ];
            const match = routes.findIndex((el) => req.url.includes(el)) > -1;

            if (!match) {
              this._notification.error('Invalid Response', event?.body?.message ?? 'The server returned invalid data.');
              throwError('Invalid response');
            }
          }
        }
      }),
      catchError((error: HttpErrorResponse) => {
        this.handleError(error);
        return throwError(error);
      }),
    );
  }

  private handleError(error: HttpErrorResponse): void {
    console.error(error);
    const status = error?.statusText;

    if (error.status === 0) {
      this._notification.error(status, 'Please check your internet connection.');
    } else if (error.status >= 400 && error.status < 500) {
      // client-side errors (4xx)
      this._notification.error(status, `${error?.error?.message ?? error?.message}`);
    } else if (error.status >= 500) {
      // server-side errors (5xx)
      this._notification.error(status, `${error?.error ?? 'Server error. Please try again later.'}`);
    } else if (error.status) {
      //  other types of errors
      this._notification.error(status, `${error?.message ?? error?.error}`);
    }
  }
}
